export default [
    'Sacola',
    'Manutencao',
    'Compre',
    'Checkout'
]